(function(){
  const BOUND = new WeakSet();

  function getSelectedText(sel){
    if (!sel) return '';
    if (sel.options && sel.selectedIndex >= 0) {
      return sel.options[sel.selectedIndex].text;
    }
    return sel.value || '';
  }

  function syncLabels(root){
    if (!root) return;
    root.querySelectorAll('.selector-wrapper').forEach(function(w){
      const cur = w.querySelector('[data-option-current]');
      if (!cur) return;
      const sel = w.querySelector('select');
      if (!sel) return;
      const txt = getSelectedText(sel);
      if (txt) cur.textContent = txt;
    });
  }

  function bind(root){
    if (!root || BOUND.has(root)) return;
    BOUND.add(root);

    const queueSync = () => setTimeout(() => syncLabels(root), 0);

    // initial
    queueSync();

    // Select changes (dropdowns + theme-morphed controls)
    root.addEventListener('change', function(e){
      if (e.target.matches('select')) queueSync();
    });
    root.addEventListener('input', function(e){
      if (e.target.matches('select')) queueSync();
    });
    root.addEventListener('click', function(e){
      if (e.target.closest('.selector-wrapper')) queueSync();
    });

    // Observe DOM mutations from swatch scripts
    const mo = new MutationObserver(queueSync);
    mo.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['value','class','aria-selected']});
  }

  function scan(){
    document.querySelectorAll('.product-detail__form__options').forEach(bind);
  }

  // Variant change / Section load events emitted by many themes
  ['variant:change','variantChanged','product:variant-change','theme:variant:change','cc:variant:change','shopify:section:load']
    .forEach(evt => document.addEventListener(evt, scan));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();